import React from 'react';
import './App.css';
import Router from './Router.js';

function App() {
  return (
    <div className="App">
        <Router/>
    </div>
  );
}
export default App;
